import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const DesignEditorHeaderRightSlot = ({ className, children }) => {
  const classes = classNames({
    'design-editor-header-right': true,
    [className]: !!className,
  });

  return <div className={classes}>{children}</div>;
};

DesignEditorHeaderRightSlot.propTypes = propTypes;

export default DesignEditorHeaderRightSlot;
